import { Box, Container, Typography, Link, Grid } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 2,
        mt: 'auto',
        bgcolor: 'grey.900',
        color: 'grey.300',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* About Section */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="white" gutterBottom>
              ServeSync
            </Typography>
            <Typography variant="body2">
              Empowering organizations to connect with passionate volunteers and make a difference in communities.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="white" gutterBottom>
              Quick Links
            </Typography>
            <Link component={RouterLink} to="/" color="inherit" display="block" sx={{ mb: 1 }}>
              Home
            </Link>
            <Link component={RouterLink} to="/register" color="inherit" display="block" sx={{ mb: 1 }}>
              Sign Up
            </Link>
          </Grid>

          {/* Support */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="white" gutterBottom>
              Support
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Need help? We're here for you.
            </Typography>
            <Link component={RouterLink} to="/help" color="inherit" display="block" sx={{ mb: 1 }}>
              Help Center
            </Link>
            <Link component={RouterLink} to="/support" color="primary.light" display="block" sx={{ fontWeight: 'medium' }}>
              Contact Support
            </Link>
          </Grid>

          {/* Legal */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="white" gutterBottom>
              Legal
            </Typography>
            <Link component={RouterLink} to="/privacy" color="inherit" display="block" sx={{ mb: 1 }}>
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/terms" color="inherit" display="block" sx={{ mb: 1 }}>
              Terms and Conditions
            </Link>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid', borderColor: 'grey.800' }}>
          <Typography variant="body2" align="center">
            © {currentYear} ServeSync. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
